import request from '@/utils/request'

export function saveToken(data) {
    return request({
        url: 'admin/sys/auth/savetoken',
        method: 'post',
        data
    })
}